/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOtherOpexDto } from '../../models/backend-other-opex-dto';
import { BackendOtherOpexRequestDto } from '../../models/backend-other-opex-request-dto';

export interface OpexesOtheropexCreate$XWwwFormUrlencoded$Params {
  body: BackendOtherOpexRequestDto;
}

export function opexesOtheropexCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: OpexesOtheropexCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
  const rb = new RequestBuilder(rootUrl, opexesOtheropexCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOtherOpexDto>;
    }),
  );
}

opexesOtheropexCreate$XWwwFormUrlencoded.PATH = '/api/opexes/otheropex/';
